<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-center">
        <div class="text-h4 font-weight-bold">
          <div style="font-size: 25px">🐓 Producción y Venta Avícola </div>
        </div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h7">
          Presiona el botón para agregar produccion de Gallinas, Pavo, Pato, Ganso, Pollitos,
           Gallos y otros
        </div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/avicola" depressed class="primary">
         <span style="font-size: 20px">🐤</span>
          <v-icon left>mdi-plus</v-icon>
          Agrega o modifica
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h6" style="font-size: 20px">
         Mis producciones y Ventas 
        </div>
        <div class="text-h8">
          Presione la producción avicola para agregar o modificar la información
        </div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas  -->
      <v-col v-if="Object.keys(avicolas).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción avicola
        </div>
      </v-col>
      <!-- listado de actividades avicolas en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="pecuaria in avicolas">
            <form-card
              :key="pecuaria.id"
              :top-text="`Finca • ${getNombreDeFinca(pecuaria.id_finca)}`"
              :top-right-text="pecuaria.fecha"
              :middle-text="`Ciclo ${pecuaria.ciclo}`"
              :bottom-right-text="producerDescription(pecuaria.productor)"
              :sincronized="pecuaria.sincronizado"
              :opaque="pecuaria.hasOutdatedRecords"
              @click="traerRegistroYNavegar(pecuaria)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'
export default {
  name: 'Avicolas',
  computed: {
    ...mapState('registros', ['avicolas']),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Avicolas')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getAvicola', { id: registro.id })
      }
      this.$router.push(`/ru/avicola/${registro.id}`)
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
